import { render, staticRenderFns } from "./Interpretations.vue?vue&type=template&id=74a4e52b&"
import script from "./Interpretations.vue?vue&type=script&lang=js&"
export * from "./Interpretations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports